

















import questComponent from '@/components/Resp/quest.vue'
import Vue from 'vue'
import {RESP_STATUS_FILLED} from '@/constants'
import Resp from '@/models/resp/Resp'
import {Ans, Quest} from '@/types/entity/RawResp'
import {Dictionary} from 'vuex'
export default Vue.extend({
  props: {
    scope: {} as () => {resp: Resp},
    options: {}
  },
  components: {
    questComponent
  },
  data () {
    return {
      ans: [] as Ans[],
      errorsQuest: [] as string[]
    }
  },
  methods: {
    onQuestCheck (ans: Ans) {
      this.errorsQuest = [];
      let curentAns = this.ans.find(item => item.qid === ans.qid)
      if (curentAns) {
        curentAns.vals = ans.vals
      } else {
        this.ans.push(ans);
      }
    },
    isErrorQuest (id: string) {
      return this.errorsQuest.some(q => q === id)
    },
    isRequiredQuestsChecked (): boolean {
      let reqIds = []
      let ansIds = this.ans.map(q => q.qid)
      for (const q of this.scope.resp.getPollQuests()) {
        if (q.required) {
          reqIds.push(q.qid)
        }
      }
      for (const id of reqIds) {
        if (!ansIds.some(item => item === id)) {
          this.errorsQuest.push(id!)
          return false;
        }
      }
      return true;
    },
    async onSubmit () {
      try {
        if (this.ans.length) {
          if (this.isRequiredQuestsChecked()) {
            await this.$store.dispatch('resp/ans', {resp_id: this.scope.resp.id, ans: this.ans})
            await this.$store.dispatch('resp/get', this.scope.resp.id)
            // @ts-ignore
            this.$message.success(this.$t('polls.sended_successfully'))
          } else {
            // @ts-ignore
            this.$message.warning(this.$t('polls.need_answer_required_question'))
          }
        } else {
          // @ts-ignore
          this.$message.warning(this.$t('polls.need_answer_one_question'))
        }
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('polls.can_not_send'))
      }
    },
    getQuestAns (qid: string): string[] {
      let ans = this.scope.resp.getQuestAns(qid)
      if (ans) {
        return ans.vals
      }
      return [];
    }
  },
  computed: {
    isFilled (): boolean {
      return this.scope.resp.isFilled;
    },
    questsMap () {
      let map: Dictionary<Quest> = {}
      for (const qeust of this.scope.resp.getPollQuests()) {
        map[qeust.qid!] = qeust
      }
      return map;
    }
  }
})
